import { useState } from 'react';
import { Dialog, Button } from '@workspace/design-system/src/components';

interface CancelPaymentRequestDialogProps {
    onClose: () => void;
    onConfirm: () => void | Promise<void>;
}

export function CancelPaymentRequestDialog({
    onClose,
    onConfirm,
}: CancelPaymentRequestDialogProps) {
    const [isLoading, setIsLoading] = useState(false);
    return (
        <Dialog>
            <Dialog.Content>
                <Dialog.Header title="결제 요청을 취소하시겠습니까?" type="question" showIcon />

                <Dialog.Footer>
                    <Button
                        styleType="basic"
                        styleSize="M-40"
                        onClick={onClose}
                        disabled={isLoading}
                    >
                        닫기
                    </Button>
                    <Button
                        styleType="destructive"
                        styleSize="M-40"
                        onClick={async () => {
                            setIsLoading(true);
                            try {
                                await onConfirm();
                                // onConfirm에서 다이얼로그를 닫을 수 있으므로 여기서는 닫지 않음
                            } catch (error) {
                                console.error('결제 요청 취소 실패:', error);
                                throw error;
                            } finally {
                                setIsLoading(false);
                            }
                        }}
                        isLoading={isLoading}
                    >
                        결제 요청 취소
                    </Button>
                </Dialog.Footer>
            </Dialog.Content>
        </Dialog>
    );
}
